import React from 'react';
import Form from '../../../../../index';
import { LinkchooserExternalTemplate } from './templates/LinkchooserExternalTemplate';
import { LinkchooserContentTemplate } from './templates/LinkchooserContentTemplate';
import { LinkchooserPersonTemplate } from './templates/LinkchooserPersonTemplate';
import IForm from '../../../../../../../../types/IForm';
import { LinkchooserLinkType } from '../../../../../../../../types/api/LinkchooserLinkType';

type LinkchooserFormProps = {
  formModel: IForm;
  onSubmit: (event: Event, model: any) => void;
  linkType: LinkchooserLinkType;
};

export function LinkchooserForm({ formModel, onSubmit, linkType }: LinkchooserFormProps) {
  const getFormByLinkType = () => {
    switch (linkType) {
      case 'page':
      case 'attachment':
        return <LinkchooserContentTemplate />;
      case 'person':
        return <LinkchooserPersonTemplate />;
      case 'external':
        return <LinkchooserExternalTemplate />;
      default:
        return null;
    }
  };

  return (
    <Form id="linkchooser-form" model={formModel} onSubmit={onSubmit}>
      {getFormByLinkType()}
    </Form>
  );
}
